import makeActionCreator from '../../utils/makeActionCreator'
import fetch from 'isomorphic-fetch'
import { sessionService } from 'redux-react-session';
import { browserHistory } from 'react-router'

import * as API       from '../../utils/config-api'
import * as endpoints from './endpoints'
import { logout } from '../../auth/list';

export const SETTING_STOCK_VALUE_PENDING = 'SETTING_STOCK_VALUE_PENDING'
export const settingStockValuePending = makeActionCreator(SETTING_STOCK_VALUE_PENDING)

export const SETTING_STOCK_VALUE_REJECTED = 'SETTING_STOCK_VALUE_REJECTED'
export const settingStockValueRejected = makeActionCreator(SETTING_STOCK_VALUE_REJECTED)

export const SETTING_STOCK_VALUE_SHOW_LIST= 'SETTING_STOCK_VALUE_SHOW_LIST'
export const settingStockValueShowList = makeActionCreator(SETTING_STOCK_VALUE_SHOW_LIST)

export const SETTING_STOCK_VALUE_HIDE_LIST = 'SETTING_STOCK_VALUE_HIDE_LIST'
export const settingStockValueHideList = makeActionCreator(SETTING_STOCK_VALUE_HIDE_LIST)

export const SETTING_STOCK_VALUE_SHOW_FORM= 'SETTING_STOCK_VALUE_SHOW_FORM'
export const settingStockValueShowForm = makeActionCreator(SETTING_STOCK_VALUE_SHOW_FORM, 'itemId')

export const SETTING_STOCK_VALUE_HIDE_FORM = 'SETTING_STOCK_VALUE_HIDE_FORM'
export const settingStockValueHideForm = makeActionCreator(SETTING_STOCK_VALUE_HIDE_FORM)

export const SETTING_STOCK_VALUE_SHOW_ITEM = 'SETTING_STOCK_VALUE_SHOW_ITEM'
export const settingStockValueShowItem = makeActionCreator(SETTING_STOCK_VALUE_SHOW_ITEM, 'itemId')


//Show Index

export const SETTING_STOCK_VALUE_LIST_FULFILLED = 'SETTING_STOCK_VALUE_LIST_FULFILLED'
export const settingStockValueListFulfilled = makeActionCreator(SETTING_STOCK_VALUE_LIST_FULFILLED, 'data')

export const SETTING_STOCK_VALUE_LIST_ERROR = 'SETTING_STOCK_VALUE_LIST_ERROR'
export const settingStockValueListError = makeActionCreator(SETTING_STOCK_VALUE_LIST_ERROR, 'message')

export function settingStockValueList() {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingStockValuePending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.index.version}${endpoints.index.path}`, {
              method  : endpoints.index.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingStockValueListFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingStockValueRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}


//Show Item

export const SETTING_STOCK_VALUE_ITEM_FULFILLED = 'SETTING_STOCK_VALUE_ITEM_FULFILLED'
export const settingStockValueItemFulfilled = makeActionCreator(SETTING_STOCK_VALUE_ITEM_FULFILLED, 'data')

export const SETTING_STOCK_VALUE_ITEM_ERROR = 'SETTING_STOCK_VALUE_ITEM_ERROR'
export const settingStockValueItemError = makeActionCreator(SETTING_STOCK_VALUE_ITEM_ERROR, 'message')

export function settingStockValueItem(profitValueId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingStockValuePending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.getItem.version}${endpoints.getItem.path.replace(":stock_prices_id", profitValueId)}`, {
              method  : endpoints.getItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingStockValueItemFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingStockValueRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}


//Add Item

export const SETTING_STOCK_VALUE_ITEM_ADD_FULFILLED = 'SETTING_STOCK_VALUE_ITEM_ADD_FULFILLED'
export const settingStockValueItemAddFulfilled = makeActionCreator(SETTING_STOCK_VALUE_ITEM_ADD_FULFILLED, 'data')

export const SETTING_STOCK_VALUE_ITEM_ADD_ERROR = 'SETTING_STOCK_VALUE_ITEM_ADD_ERROR'
export const settingStockValueItemAddError = makeActionCreator(SETTING_STOCK_VALUE_ITEM_ADD_ERROR, 'message')

export function settingStockValueAddItem(data) {
  let formData = new FormData()

  formData.append("date", data["date"]);
  formData.append("price", data["price"]);

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingStockValuePending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.addItem.version}${endpoints.addItem.path}`, {
              method  : endpoints.addItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingStockValueItemAddFulfilled(json.data))
              }else{
                dispatch(settingStockValueItemAddError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingStockValueRejected(err))
          })
    })
    .catch(err => {
    dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Update Item

export const SETTING_STOCK_VALUE_ITEM_UPDATE_FULFILLED = 'SETTING_STOCK_VALUE_ITEM_UPDATE_FULFILLED'
export const settingStockValueItemUpdateFulfilled = makeActionCreator(SETTING_STOCK_VALUE_ITEM_UPDATE_FULFILLED, 'data')

export const SETTING_STOCK_VALUE_ITEM_UPDATE_ERROR = 'SETTING_STOCK_VALUE_ITEM_UPDATE_ERROR'
export const settingStockValueItemUpdateError = makeActionCreator(SETTING_STOCK_VALUE_ITEM_UPDATE_ERROR, 'message')

export function settingStockValueUpdateItem(itemId, data) {
  let formData = new FormData()

  formData.append('_method', 'PUT')
  formData.append("date", data["date"]);
  formData.append("price", data["price"]);


  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingStockValuePending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.updateItem.version}${endpoints.updateItem.path.replace(":stock_prices_id", itemId)}`, {
              method  : endpoints.updateItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingStockValueItemUpdateFulfilled(json.data))
              }else{
                dispatch(settingStockValueItemUpdateError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingStockValueRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Delete Item

export const SETTING_STOCK_VALUE_ITEM_DELETE_FULFILLED = 'SETTING_STOCK_VALUE_ITEM_DELETE_FULFILLED'
export const settingStockValueItemDeleteFulfilled = makeActionCreator(SETTING_STOCK_VALUE_ITEM_DELETE_FULFILLED, 'data')

export const SETTING_STOCK_VALUE_ITEM_DELETE_ERROR = 'SETTING_STOCK_VALUE_ITEM_DELETE_ERROR'
export const settingStockValueItemDeleteError = makeActionCreator(SETTING_STOCK_VALUE_ITEM_DELETE_ERROR, 'message')

export function settingStockValueDeleteItem(profitValueId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingStockValuePending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.deleteItem.version}${endpoints.deleteItem.path.replace(":stock_prices_id", profitValueId)}`, {
              method  : endpoints.deleteItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
            if(json.status === "ok"){
              dispatch(settingStockValueItemDeleteFulfilled(json.data))
              dispatch(settingStockValueList(profitValueId))
            }else{
              dispatch(settingStockValueItemDeleteError(json.message))
            }

          })
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingStockValueRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })





  }
}
